import { gql } from '@apollo/client'

export const SearchTracks = gql`
    query SearchTracks($params: TrackSearchParams, $cursor: String, $limit: Int) {
        searchTracks(params: $params, cursor: $cursor, limit: $limit) {
            cursor
            tracks {
                id
                album
                artist
                bitRate
                codec
                composer
                completed
                contributors {
                    id
                    username
                }
                coverArt {
                    full
                    thumb250
                    thumb500
                    thumb1200
                }
                created
                date
                duration
                files {
                    bitRate
                    duration
                    key
                    size
                }
                genre
                roomId
                size
                tags
                title
                track
                updated
                userId
                youtubeId
            }
        }
    }
`

export default SearchTracks
